import { createSlice } from '@reduxjs/toolkit';

import { StatisticsResult } from '@/features/appusage/appUsageApi';

export interface AppUsageScope {
  result:			StatisticsResult;
  loaded:			boolean;
}

export interface AppUsageState {
  scopes:			{ [key: string]: AppUsageScope };
}

// `sort` only reorders/truncates the rooms[] ranking, but the cap makes it
// data-bearing (top-500-by-screentime and top-500-by-seconds are different
// SETS, not just different orderings of one set) — so it has to be part of
// the cache key like every other scope dimension, not applied client-side.
export function appUsageScopeKey(projectId: string, roomNo: string, period: string, offset: number, sort: string): string {
  return projectId + "|" + (roomNo || "") + "|" + period + "|" + offset + "|" + sort;
}

const initialState: AppUsageState = { scopes: {} };

export const appUsageSlice = createSlice({
  name: 'appusage',
  initialState,
  reducers: {
    setResult: (state, action) => {
      state.scopes[action.payload.key] = {
        result:		action.payload.result,
        loaded:		true,
      };
    },
    clearScope: (state, action) => {
      delete state.scopes[action.payload];
    },
    clearAll: (state) => {
      state.scopes = {};
    },
  },
});

export function selectAppUsageScope(state: AppUsageState, key: string): AppUsageScope | undefined {
  return state.scopes[key];
}
